import React, { useEffect, useState } from 'react';
import { cn } from '@cotera/client/v0/lib/utils';

/** Cycles through ... -> .. -> . -> (empty) -> . -> .. -> ... */
const DOT_SEQUENCE = [3, 2, 1, 0, 1, 2] as const;

export const AnimatedEllipsis: React.FC<{ className?: string }> = ({
  className,
}) => {
  const [index, setIndex] = useState(0);
  const dotCount = DOT_SEQUENCE[index % DOT_SEQUENCE.length] ?? 0;

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % DOT_SEQUENCE.length);
    }, 400);
    return () => clearInterval(id);
  }, []);

  return (
    <span className={cn('inline-block min-w-[1em]', className)} aria-hidden>
      {'.'.repeat(dotCount)}
    </span>
  );
};
